import { PAGE_NAMES, USER_PROFILE_ACL_ACTIONS, USER_PROFILE_RESOURCES } from 'constant';
import usePermission from 'commons-ui/src/permission/usePermission';

export const makeActionList = () => {
	const { hasPermission } = usePermission();
	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'link',
				id: 'link',
				isEnabled: () =>
					hasPermission({
						configPageName: PAGE_NAMES.userProfile,
						configResourceName: USER_PROFILE_RESOURCES.kycDetails,
						configActionName: USER_PROFILE_ACL_ACTIONS.activatePayoutRecord
					})
			}
		]
	};
};

export default {
	makeActionList
};
